import React from 'react';
import styles from './CardVisualizer.module.scss';
import { Code, ExpirationDate, CardNumber } from '../CardVisualizer/CardVisualizer.components';

export type CardVisualizerProps = {
    /** It allow to determine the method to process the credit card  */
    method: string;
    /** It determine the classname to be computed*/
    className?: string;
    /** It determine the pan */
    pan?: string;
    /** It determine the cvc */
    cvc?: string;
    /** It determine the expiration date*/
    expiry?: string;
    issuer?: string;
    isRipley?: boolean;
    focused?: 'pan' | 'cvc' | 'expiry';
    showPanPassword?: boolean;
    showCvcPassword?: boolean;
};

export const CardVisualizer: React.FC<CardVisualizerProps> = (props) => {
    let variant = props.issuer;
    if (props.isRipley && props.method === 'Ripley') {
        variant = props.issuer === 'mastercard' ? `${props.issuer}-ripley` : 'normal-ripley';
    }

    if (props.isRipley && props.method === 'Chek') {
        variant = `mastercard-chek`;
    }

    let calculatedClassName = `${styles['card']} ${styles['card-' + variant]}`;

    if (props.focused === 'cvc' && props.issuer !== 'amex') {
        calculatedClassName += ` ${styles['card-flipped']}`;
    }

    return (
        <div className={styles['wrapper']}>
            <div className={styles['container'] + ' ' + (props.className ?? '')}>
                <div className={calculatedClassName}>
                    <div className={styles['card-front']}>
                        <div className={styles['card-chip']} />
                        <div className={styles['card-issuer']} />
                        <Code cvc={props.cvc ?? ''} focused={props.focused ?? ''} />
                        <CardNumber
                            number={
                                props.showPanPassword
                                    ? props.pan ?? ''
                                    : props.pan?.replace(/./g, String.fromCharCode(8226)) ?? ''
                            }
                            focused={props.focused ?? ''}
                        />
                        <ExpirationDate expiry={props.expiry ?? ''} focused={props.focused ?? ''} />
                    </div>
                    <div className={styles['card-back']}>
                        <div className={styles['card-stripe']} />
                        <div className={styles['card-signature']} />
                        <div
                            className={`${styles['card-cvc']} ${
                                props.focused === 'cvc' ? styles['focused'] : ''
                            } tlPrivate`}
                        >
                            {props.showCvcPassword
                                ? props.cvc
                                : props.cvc?.replace(/./g, String.fromCharCode(8226))}
                        </div>
                        <div className={styles['card-issuer']} />
                    </div>
                </div>
            </div>
        </div>
    );
};
